import { __makeTemplateObject } from '../../node_modules/tslib/tslib.es6.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { media, Heading, useGreaterThan } from '@elseu/sdu-titan';
import styled, { css } from 'styled-components';
import { VideoWrapper } from '../../components/Video/Video.js';
import { Section, getSectionSpacing } from '../Section/Section.js';

var StyledSectionVideo = styled(Section)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n"], ["\n  background: ", ";\n"])), function (_a) {
  var background = _a.background,
    theme = _a.theme;
  return background === 'sand' ? theme.designTokens.colors.secondary10 : theme.designTokens.colors.grey0;
});
var ContentWrapper = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme,
    isSplit = _a.isSplit;
  return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    ", "\n\n    .", " {\n      ", "\n      flex: 1;\n    }\n\n    ", "\n  "], ["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    ", "\n\n    .", " {\n      ", "\n      flex: 1;\n    }\n\n    ", "\n  "])), getSectionSpacing({
    theme: theme,
    yPadding: [4, 8, 12, 24],
    xPadding: [4, 8, 12, 24]
  }), VideoWrapper.styledComponentId, !isSplit && "margin: ".concat(theme.spacing[4], " 0;"), isSplit && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      ", "\n    "], ["\n      ", "\n    "])), media.greaterThan('s')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        flex-direction: row;\n        gap: ", "};\n      "], ["\n        flex-direction: row;\n        gap: ", "};\n      "])), theme.spacing[8])));
});
var Header = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  max-width: 600px;\n  flex: 1;\n  text-align: center;\n"], ["\n  max-width: 600px;\n  flex: 1;\n  text-align: center;\n"])));
var Title = styled(Heading)(templateObject_7 || (templateObject_7 = __makeTemplateObject([""], [""])));
var Description = styled.p(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    ", "\n\n    ", "\n  "], ["\n    ", "\n\n    ", "\n  "])), theme.designTokens.fonts.paragraphsParagraph, media.greaterThan('s')(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      ", "\n    "], ["\n      ", "\n    "])), theme.designTokens.fonts.paragraphsParagraphLarge));
});
var VideoContainer = styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  flex: 1;\n"], ["\n  flex: 1;\n"])));
var SectionVideo = function (_a) {
  var title = _a.title,
    description = _a.description,
    name = _a.name,
    reference = _a.reference,
    background = _a.background,
    video = _a.video,
    isSplit = _a.isSplit;
  var hasWrapper = useGreaterThan('s') && isSplit;
  return jsx(StyledSectionVideo, {
    name: name,
    reference: reference,
    background: background,
    children: jsxs(ContentWrapper, {
      isSplit: isSplit,
      children: [jsxs(Header, {
        children: [title && jsx(Title, {
          heading: "h2",
          spaceAfter: 2,
          children: title
        }), description && jsx(Description, {
          children: description
        })]
      }), hasWrapper ? jsx(VideoContainer, {
        children: video
      }) : video]
    })
  });
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;

export { SectionVideo, StyledSectionVideo };
//# sourceMappingURL=SectionVideo.js.map
